import { isEmpty } from "lodash";
import reduxStore from "../../../configureEnvStore";
import { CALL_DATA, GLOBAL_MEETING_DATA, PublicVariables } from "../../../constants/PublicVariables";
import { FIREBASE_EVENT_CATEGORY, FIREBASE_LOG_KEY } from "../../../constants/FirebaseConstants";
import { FLASH_STATE } from "../../../constants/FlashConstants";
import {
    setIsConfirmMultiStreamOpen,
    setIsIosPlayPauseIconModalOpen,
    setIsVideoButtonClickDisable,
    setIsStartCameraAsPerAgentRequestPermission,
} from "../../../reducers/common-reducer";
import {
    checkDeviceHasCamIssue,
    dualStreamEnabled,
    isVirtualBackGroundFeatureAvailable,
    showMeVideoEnabled,
    singleUserEnabled,
} from "../../../shared/utility";
import { setNotAllowedCamera, setIsConfirmVideoModalOpen, setVideoError, setStartLocalVideo } from "../../../reducers/twilioEvents-reducer";
import { setFlashState } from "../../../reducers/flash-reducer";
import { LogFirebase } from "../../../services/firestore";
import zoomService from "../../../services/zoomService";
import livePointerService from "../../LivePointer/livePointerService";
import { DISABLE, ENABLED, WAITING_CLOCK_ICON } from "../../../constants/Constants";
import { STATUS } from "../../../constants/LivePointerConstants";
import { sendDataTrack, sendMsgForPointer, sendRequestToAgentStartAudioOrVideo, sendVideoStatusToAgent } from "../../../shared/dataTrackFunction";
import { addRemoveAutoWidthClass, changeSelectedCamera, getWorkingCamera } from "../../CallScreens/CallTopbar/CallSettings/CallSettingUtils";
import { addRemoveLatLong } from "../../LiveLocation/LocationUtils";
import flashService from "../../../services/flashService";
import { showGridView } from "../../GalleryView/GalleryViewUtils";
import { CAMERA_FACE, CAMERA_FACING_MODE, ERROR_TYPE, MAX_VIDEO, MEDIA_PERMISSIONS, VIDEO_FPS } from "../../../constants/CallSettingConstants";
import {
    checkIfVideoQualityIsHD,
    expandViewEnabled,
    handleErrorForVideo,
    handleStartLocalVideoTrackForSingleStream,
    handleStopLocalVideoTrackForSingleStream,
} from "../Room/roomFunction";
import {
    attachTracks,
    createMyLocalVideoTrack,
    detachTracks,
    getPublishVideoContainer,
    getTracksByType,
    removeVideoElement,
    restartLocalVideoTracks,
    setTrackName,
} from "../twilioCallUtility";
import { updateStreamingStatusOnEvent } from "../videoScreenShareOverrideFunction";
import { getLocalVideoTrack, getRoom, getScreenShareLocalTrack, setLocalVideoTrack } from "../Room/roomService";
import googleEvent from "../../../services/googleEvent";
import DetectRTC from "detectrtc";
import navigatorService from "../../../services/navigatorService";
import { setCurrentCameraDevice, setIsFrontCameraSelected, setVideoFacingmode, setWorkingCam } from "../../../reducers/call-setting-reducer";
import { stopScreenShare } from "../ScreenShare/ScreenShareUtils";
import { removeVideoNotificationModal } from "../../ParticipantsList/HostControlledParticipants/HostControlledParticipantUtils";
import CustomToast from "../../UI/customToast";
import Localize from "../../../locale/Localize";
import { VIRTUAL_BACKGROUND } from "../../../constants/VirtualBackgroundConstant";
import mediaDeviceService from "../../../services/mediaDeviceService";
import { applyVirtualBackgroundEffect } from "../../VirtualBackground/VirtualBackgroundUtils";

/**this will call stop video or show pop up to override */
export const handleStartStopVideo = (isFromButtonClick = false, isFromAgentRequest = false) => {
    reduxStore.dispatch(setIsVideoButtonClickDisable(true)); // disable video button(button click variable)
    // old callStopVideo function
    const { isLocalUserScreenSharing, streamingPartiIdentity, videoStreamingUsers, screenSharingUsers, startLocalVideo } =
        reduxStore.getState().twilioEvents;
    const { expandView } = reduxStore.getState().commonReducer;

    const isLocalUserStreaming = streamingPartiIdentity === CALL_DATA.localIdentity;
    /* - If the agent sends the camera request to the guest, set the variable below to true. 
       - This variable will be used in override scenarios for both single-stream and multi-stream.
       - because we do not resend the request to the agent if it has already been sent to the guest.
    */
    if (isFromAgentRequest) {
        reduxStore.dispatch(setIsStartCameraAsPerAgentRequestPermission(true));
    }
    if (!dualStreamEnabled()) {
        if (!(isEmpty(videoStreamingUsers) && isEmpty(screenSharingUsers)) && !startLocalVideo) {
            reduxStore.dispatch(setIsConfirmVideoModalOpen(true));
            reduxStore.dispatch(setIsVideoButtonClickDisable(false)); // enable video button(button click variable)
        } else {
            performStartStopVideo(isFromButtonClick); // old stopvideo function
        }
    } else {
        if (isLocalUserScreenSharing) {
            reduxStore.dispatch(setIsConfirmMultiStreamOpen(true));
            reduxStore.dispatch(setIsVideoButtonClickDisable(false)); // enable video button(button click variable)
        } else if (expandView && isLocalUserStreaming) {
            showGridView(CALL_DATA.localIdentity, true);
            performStartStopVideo(isFromButtonClick); // old stopvideo function
        } else {
            performStartStopVideo(isFromButtonClick); // old stopvideo function
        }
    }
};

export const checkIsVideoPermissionBlock = () => {
    const { cameraPermission } = reduxStore.getState().callSetting;
    if (cameraPermission == MEDIA_PERMISSIONS.BLOCKED) {
        reduxStore.dispatch(setVideoError(ERROR_TYPE.PERMISSION));
        reduxStore.dispatch(setNotAllowedCamera(true));
        reduxStore.dispatch(setIsVideoButtonClickDisable(false)); // enable video button(button click variable)

        LogFirebase("video", "video_track_creation_failed", { cameraPermission: MEDIA_PERMISSIONS.BLOCKED });
        return true;
    }
    return false;
};

export const attachTrackInContainer = (localTrack, fromWhere, retries = 10, timeout = 600) => {
    setTimeout(() => {
        if (fromWhere === "callsettingVideo" || fromWhere === "callsettingVideo_vb") {
            const callsettingVideoVideoElement = document.getElementById("callsettingVideo");
            const virtualBackgroundVideoVideoElement = document.getElementById("callsettingVideo_vb");
            attachTracks([localTrack], callsettingVideoVideoElement);
            attachTracks([localTrack], virtualBackgroundVideoVideoElement);
        } else {
            const previewContainer = getPublishVideoContainer(fromWhere);
            if (fromWhere === "screenshare" && previewContainer) {
                removeVideoElement(previewContainer);
            }
            if (previewContainer) {
                removeVideoElement(previewContainer);
                attachTracks([localTrack], previewContainer);
            } else if (retries > 0) {
                console.warn("previewContainer not found. Retrying...");
                attachTrackInContainer(localTrack, "", retries - 1); // Retry
            } else {
                console.error("previewContainer not found after multiple attempts.");
            }
        }
    }, timeout);
};

export const createTwilioVideoTrack = (fromWhere) => {
    return new Promise((resolve) => {
        const room = getRoom();
        const videoParams = addVideoParams(fromWhere);
        console.log(videoParams, "videoParams____");
        googleEvent.logEvent("STARTED_VIDEO");
        createMyLocalVideoTrack(videoParams).then(
            function (localTrack) {
                // for HD quality in iOS apply class
                removeVideoNotificationModal();
                if (checkIfVideoQualityIsHD(GLOBAL_MEETING_DATA.device_type)) {
                    addRemoveAutoWidthClass(true);
                } else {
                    addRemoveAutoWidthClass(false);
                }
                if (isVirtualBackGroundFeatureAvailable()) {
                    const { selectedVirtualBackgroundImageId, virtualBackgroundLocalImageUrl } = reduxStore.getState().callSetting;
                    const { isCallSettingDrawerOpen } = reduxStore.getState().commonReducer;
                    const selectedLocalImageUrl =
                        selectedVirtualBackgroundImageId === VIRTUAL_BACKGROUND.LOCAL_IMAGE_ID ? virtualBackgroundLocalImageUrl : null;
                    LogFirebase("VirtualBackground", "start_from_local_video_start", selectedVirtualBackgroundImageId);
                    if (selectedVirtualBackgroundImageId !== VIRTUAL_BACKGROUND.NONE_EFFECT_ID && !isCallSettingDrawerOpen) {
                        LogFirebase("VirtualBackground", "apply_from_local_video_start", selectedVirtualBackgroundImageId);
                        applyVirtualBackgroundEffect(selectedVirtualBackgroundImageId, selectedLocalImageUrl);
                    }
                }
                LogFirebase("Video", "video_track_created", { identity: CALL_DATA.localIdentity });
                reduxStore.dispatch(setStartLocalVideo(true));
                setLocalVideoTrack(localTrack);
                localTrack.enable();
                room.localParticipant.publishTrack(localTrack);
                handleStartLocalVideoTrackForSingleStream();
                updateStreamingStatusOnEvent(true, CALL_DATA.localIdentity);
                const previewContainer = getPublishVideoContainer();
                removeVideoElement(previewContainer);
                attachTrackInContainer(localTrack, "", expandViewEnabled() && dualStreamEnabled() ? 0 : 10);
                setTimeout(() => {
                    sendVideoStatusToAgent(ENABLED);
                }, 500);
                // Auto-start live pointer after local video starts - pass track for proper Twilio event handling
                // For single stream, handleStartLocalVideoTrackForSingleStream already calls autoStartLivePointer
                // Only call here for dual stream to pass the track for Twilio event handling
                if (dualStreamEnabled()) {
                    LogFirebase("AutoLivePointer", "createTwilioVideoTrack - local_video_published_dual_stream_and_start_auto_live-pointer", true);
                    livePointerService.autoStartLivePointer("local_video", localTrack);
                }
                /* check if vdo paused : with GSM/PSTN call video gets paused when safari focuses */
                if (PublicVariables.isIOSDevice) {
                    playIfVideoIsPaused();
                    addVideoPausedCheck.start(); //add interval to check video pause
                }
                resolve(true);
            },
            function (error) {
                LogFirebase("video", "video_track_creation_failed", { error: error });
                handleErrorForVideo(error);
                console.log(error);
                resolve(true);
            }
        );
    });
};

export const publishVideo = (fromWhere) => {
    if (checkIsVideoPermissionBlock()) {
        return;
    }
    const { currentCameraDevice, isFrontCameraSelected } = reduxStore.getState().callSetting;
    reduxStore.dispatch(setWorkingCam(false));
    if (!getLocalVideoTrack()) {
        let getWorkingCam = true;
        if (fromWhere && fromWhere == "joinCall" && showMeVideoEnabled()) {
            if (PublicVariables.featureFlag.SHOWMEVIDEO == CAMERA_FACE.FRONT) {
                getWorkingCam = false;
            }
        } else if (fromWhere && fromWhere == "flipCamera" && !isFrontCameraSelected) {
            // `getWorkingCam` already defaults to `true`, no need to reassign, comes here only when switching to back
        } else if (currentCameraDevice?.deviceId) {
            getWorkingCam = false;
        }

        if (getWorkingCam && checkDeviceHasCamIssue()) {
            getWorkingCamera().then(function (workingcam) {
                reduxStore.dispatch(setWorkingCam(workingcam));
                reduxStore.dispatch(setCurrentCameraDevice(workingcam));
                return createTwilioVideoTrack(fromWhere);
            });
        } else {
            return createTwilioVideoTrack(fromWhere);
        }
    }
};

export const addVideoParams = (fromWhere) => {
    const { isFrontCameraSelected, currentSelectedVideoQuality, currentCameraDevice } = reduxStore.getState().callSetting;
    let video = {};
    let frontCameraSelected = isFrontCameraSelected;
    video.name = setTrackName("video");
    const { workingCam } = reduxStore.getState().callSetting;
    if (DetectRTC.isMobileDevice || navigatorService.isIpadOS()) {
        if (fromWhere == "joinCall" && !workingCam) {
            //check if guest has default camera facing setting in CE.
            if (PublicVariables.featureFlag.SHOWMEVIDEO == CAMERA_FACE.FRONT) {
                video.facingMode = CAMERA_FACING_MODE.FRONT;
                frontCameraSelected = true;
            } else {
                video.facingMode = CAMERA_FACING_MODE.BACK;
                frontCameraSelected = false;
            }
        } else {
            //facing mode flow as per flip camera flag
            if (workingCam && checkDeviceHasCamIssue()) {
                video.deviceId = { exact: workingCam?.deviceId };
            } else if (isFrontCameraSelected) {
                video.facingMode = CAMERA_FACING_MODE.FRONT; // front
                frontCameraSelected = true;
            } else {
                video.facingMode = CAMERA_FACING_MODE.BACK; // environment
                frontCameraSelected = false;
            }
        }
        reduxStore.dispatch(setIsFrontCameraSelected(frontCameraSelected));
        reduxStore.dispatch(setVideoFacingmode(video.facingMode));
    }
    //frame rate and MAX height width
    if (currentSelectedVideoQuality.value) {
        const resolutionParam = getSelectedResolutionParams();
        video = { ...video, ...resolutionParam };
    } else {
        video.frameRate = VIDEO_FPS; // 20
        if (DetectRTC.isMobileDevice || navigatorService.isIpadOS()) {
            video.width = { max: MAX_VIDEO.maxVideoWidthMobile };
            video.height = { max: MAX_VIDEO.maxVideoHeightMobile };
        } else {
            video.width = { max: MAX_VIDEO.maxVideoWidthWeb };
            video.height = { max: MAX_VIDEO.maxVideoHeightWeb };
        }
    }
    //call settings
    if (!fromWhere) {
        if (currentCameraDevice?.deviceId) {
            video.deviceId = { exact: currentCameraDevice.deviceId }; // NOTE: on ios safari - it respects the deviceId only if its exact.
        }
    } else if (fromWhere == "flipCamera" && !workingCam) {
        //if coming form flip camera then change selected device id
        changeSelectedCamera(video.facingMode);
    }
    console.log("video constraints");
    console.log(video);
    return video;
};

const getSelectedResolutionParams = () => {
    const videoParam = {};
    const { currentSelectedVideoQuality, videoQualityResolutionList } = reduxStore.getState().callSetting;

    if (currentSelectedVideoQuality.value == "low") {
        videoParam.frameRate = videoQualityResolutionList["LD"].FRAMERATE;
        videoParam.width = { max: videoQualityResolutionList["LD"].WIDTH };
        videoParam.height = { max: videoQualityResolutionList["LD"].HEIGHT };
    } else if (currentSelectedVideoQuality.value == "medium") {
        videoParam.frameRate = videoQualityResolutionList["SD"].FRAMERATE;
        videoParam.width = { max: videoQualityResolutionList["SD"].WIDTH };
        videoParam.height = { max: videoQualityResolutionList["SD"].HEIGHT };
    } else if (currentSelectedVideoQuality.value == "high") {
        videoParam.frameRate = videoQualityResolutionList["HD"].FRAMERATE;
        videoParam.width = { max: videoQualityResolutionList["HD"].WIDTH };
        videoParam.height = { max: videoQualityResolutionList["HD"].HEIGHT };
    }
    return videoParam;
};

export const unpublishVideo = () => {
    sendVideoStatusToAgent(DISABLE);
    reduxStore.dispatch(setStartLocalVideo(false));
    addRemoveAutoWidthClass(false);
    handleStopLocalVideoTrackForSingleStream(CALL_DATA.localIdentity);
    addVideoPausedCheck.stop();
    googleEvent.logEvent("STOPPED_VIDEO");
    updateStreamingStatusOnEvent(false, CALL_DATA.localIdentity);

    const room = getRoom();
    const localVideoTracks = getTracksByType(room.localParticipant, "video");
    const localVideoTrack = getLocalVideoTrack();

    localVideoTrack.disable();
    room.localParticipant.unpublishTracks(localVideoTracks);
    detachTracks(localVideoTracks);
    localVideoTrack.stop();
    setLocalVideoTrack(null);
    reduxStore.dispatch(setIsVideoButtonClickDisable(false)); // enable video button(button click variable)
};

// old stopvideo function
export const performStartStopVideo = async (isFromButtonClick = false) => {
    const {
        isLocalUserScreenSharing,
        streamingPartiIdentity,
        isOpponentUserScreenSharing,
        videoStreamingUsers,
        startLocalVideo,
        localUserNetworkQuality,
    } = reduxStore.getState().twilioEvents;
    const { pointerOn } = reduxStore.getState().livePointer;
    const { isStartCameraAsPerAgentRequestPermission } = reduxStore.getState().commonReducer;
    reduxStore.dispatch(setIsVideoButtonClickDisable(true)); // disable video button(button click variable)
    LogFirebase(FIREBASE_EVENT_CATEGORY.REQUEST_MIC_CAMERA, "is_video_button_from_click", isFromButtonClick);
    LogFirebase(
        FIREBASE_EVENT_CATEGORY.REQUEST_MIC_CAMERA,
        "is_start_camera_as_per_agent_premission_request",
        isStartCameraAsPerAgentRequestPermission
    );
    if (startLocalVideo) {
        const previewContainer = getPublishVideoContainer();
        removeVideoElement(previewContainer);

        if (flashService.isLocalUsersVideoStreamOn() && flashService.isSupportedMobileBrowser()) {
            const currentFlashState = reduxStore.getState().flash.currentFlashState;
            if (currentFlashState !== FLASH_STATE.DISABLED) {
                CALL_DATA.disabledFlash = true;
                reduxStore.dispatch(setFlashState(FLASH_STATE.DISABLED));
                if (!flashService.isOnlyLocalFlash()) {
                    const msg = flashService.generateDataTrackForLocalFlash(FLASH_STATE.DISABLED);
                    sendDataTrack(msg);
                    LogFirebase(FIREBASE_EVENT_CATEGORY.Flash, FIREBASE_LOG_KEY.SendMessage, msg);
                }
            }
        } else {
            CALL_DATA.disabledFlash = true;
            reduxStore.dispatch(setFlashState(FLASH_STATE.DISABLED));
        }

        // do not turn off LP if dual stream is ON video stop
        if (!dualStreamEnabled()) {
            if (pointerOn) {
                livePointerService.turnOffLivePointer();
            }
        }

        //unpublish video
        unpublishVideo();

        /*  send unpublish msg only for single stream
            if expand view on and LP ON any user video stop then we don't send pointer status
            Also skip if pointer is already off (e.g., turned off by livePointerOnMarkupOCR before video stops)
        */
        if (livePointerService.getLivePointerFeatureFlagValue() == ENABLED && !dualStreamEnabled() && pointerOn) {
            sendMsgForPointer(STATUS.OFF);
        }
    } else {
        if (isLocalUserScreenSharing) {
            // local user screen sharing is on than
            LogFirebase("Screenshare", "start", "override local screen share");
            stopScreenShare();
        } else {
            if (isOpponentUserScreenSharing) {
                // remote user screen sharing is on than
                LogFirebase("Screenshare", "start", "override remote screen share");
                // setIsOpponentUserScreenSharing for to set oppScreenshare to false
            } else if (!isEmpty(videoStreamingUsers) && !videoStreamingUsers.includes(CALL_DATA.participantIdentity)) {
                // remote video streaming is on than
                LogFirebase("Video", "start_video", "override remote video " + streamingPartiIdentity);
            }
        }
        if (!isStartCameraAsPerAgentRequestPermission && isFromButtonClick && requestCamPermissionToTheAgent()) {
            LogFirebase(FIREBASE_EVENT_CATEGORY.REQUEST_MIC_CAMERA, "send_camera_request_permission_to_the_agent", true);
            reduxStore.dispatch(setIsVideoButtonClickDisable(false)); // enabled video button(button click variable)
            return;
        }
        reduxStore.dispatch(setIsStartCameraAsPerAgentRequestPermission(false));
        if (checkIsVideoPermissionBlock()) {
            return;
        }
        // Updating the video quality of the video
        //publish video
        publishVideo();
        setTimeout(() => {
            addRemoveLatLong(CALL_DATA.Latitude, CALL_DATA.Longitude, localUserNetworkQuality);
        }, 500);

        // Reset Zoom for guest users
        if (GLOBAL_MEETING_DATA.isGuest) {
            zoomService.resetZoom();
        }
    }

    // If local user changes video stream and is on a mobile device, disable pinch zoom
    if (PublicVariables.isMobile) {
        zoomService.disablePinchZoom(); // disable pinch zoom browser for local user
    }
};

export const getVideoTracksByIdentity = (identity) => {
    let trackArr = [];
    const { startLocalVideo, isLocalUserScreenSharing } = reduxStore.getState().twilioEvents;
    const screenShareLocalTrack = getScreenShareLocalTrack();
    const localVideoTrack = getLocalVideoTrack();
    if (CALL_DATA.localIdentity == identity) {
        if (startLocalVideo) {
            trackArr.push(localVideoTrack);
        } else if (isLocalUserScreenSharing) {
            trackArr.push(screenShareLocalTrack);
        }
    } else {
        const room = getRoom();
        room?.participants?.forEach(function (remoteParticipant, val) {
            if (remoteParticipant?.videoTracks?.size > 0 && remoteParticipant?.identity == identity) {
                trackArr = getTracksByType(remoteParticipant, "video");
            }
        });
    }
    return trackArr;
};

const showLocalVideo = function (video_id, localVideoContainer) {
    if (document.getElementById(video_id)) {
        document.getElementById(video_id).style.display = "none";
    }
    const localContainer = document.getElementById(localVideoContainer);
    let localtracks = getLocalVideoTrack();
    if (localtracks) {
        removeVideoElement(localContainer);
        attachTracks([localtracks], localContainer, "fromCallBack", function () {
            // Use common function to check if restart is needed for iOS
            // This prevents torch/flashlight flickering when flash feature is enabled
            if (flashService.shouldRestartLocalVideoTracksForIOSDeviceAndSafari()) {
                restartLocalVideoTracks(addVideoParams());
                LogFirebase("MultiStream", "In CallSettings", "restartLocalVideoTracks");
            }
        });
    }
};

export const showLocalVideoInCallSettings = function () {
    showLocalVideo("callsettingVideo", "localVideoContainer");
    showLocalVideo("callsettingVideo_vb", "localVideoContainer_vb");
};

/**this will apply video change in Twilio call */
const applyVideoInputDeviceSelection = function () {
    const room = getRoom();
    if (room) {
        publishVideo().then(
            function () {
                showLocalVideoInCallSettings();
                mediaDeviceService.hideCallSettingCamLoading();
            },
            function (error) {
                console.error("applyVideoInputDeviceSelection failed:", error);
            }
        );
    }
};

/**changes video input when video tracks exist */
export const videoInputDeviceChange = function () {
    unpublishVideo();
    setTimeout(() => {
        applyVideoInputDeviceSelection();
    }, 100);
};

/**in iOS device - video gets paused when GSM/PSTN call is ON */
export const playIfVideoIsPaused = function (vid, identity) {
    let vidElement;

    if (vid) {
        vidElement = vid;
        LogFirebase("Video_play_pause", "_video_paused_if", { vidElement: vidElement });
    } else {
        const videoId = !expandViewEnabled() ? `galleryVideo_${identity ? identity : CALL_DATA.localIdentity}` : "expandedVideo";
        vidElement = document.getElementById(videoId)?.querySelector("video");
        LogFirebase("Video_play_pause", "_video_paused_else", { videoId: videoId, vidElement: vidElement });
    }
    if (vidElement) {
        try {
            console.log("VDO is Paused? " + vidElement.paused);
            if (vidElement?.paused) {
                LogFirebase("Video_play_pause", "_video_paused", "true");
                //video paused - play it
                vidElement
                    ?.play()
                    .then(() => {
                        console.log("outremote video played");
                        LogFirebase("Video_play_pause", "_video_playing", "true");
                    })
                    .catch((error) => {
                        LogFirebase("Video_play_pause", "Play Icon Modal is Open");
                        reduxStore.dispatch(setIsIosPlayPauseIconModalOpen(true));
                        LogFirebase("Video_play_pause", "Error_playing_video:", error);
                    });
            } else {
                //video playing;
                console.log("outremote video already playing");
            }
        } catch (err) {
            vidElement.play();
            console.log("outremote video played 2");
        }
    }
};

export const addVideoPausedCheck = (() => {
    let videoPausedIntervalId = null;
    const start = (identity) => {
        videoPausedIntervalId = setInterval(function () {
            const { videoStreamingUsers, screenSharingUsers } = reduxStore.getState().twilioEvents;
            if (!isEmpty(videoStreamingUsers) || !isEmpty(screenSharingUsers)) {
                if (identity) {
                    playIfVideoIsPaused(null, identity);
                } else {
                    playIfVideoIsPaused();
                }
            }
        }, 15000);
    };
    const stop = () => {
        clearInterval(videoPausedIntervalId);
    };
    return { start, stop };
})();

export const requestCamPermissionToTheAgent = () => {
    const { joinMeetingData } = reduxStore.getState().joinMeeting;
    const { startLocalVideo } = reduxStore.getState().twilioEvents;
    const { cameraPermission } = reduxStore.getState().callSetting;

    if (
        !GLOBAL_MEETING_DATA.isAgent &&
        joinMeetingData?.sessionConfigurations?.ASKCAMERAPERMISSION == ENABLED &&
        cameraPermission !== MEDIA_PERMISSIONS.BLOCKED &&
        !startLocalVideo &&
        !singleUserEnabled()
    ) {
        const localizedValues = Localize[PublicVariables.currentLanguageObj.languageCode];
        const waitingToastText = localizedValues?.camera_request_sent + " " + localizedValues?.waiting_for_host_approval;
        const participantName = CALL_DATA.participantUserName;
        sendRequestToAgentStartAudioOrVideo("2", participantName); // 1 mic, 2 Camera
        const uniqueKey = `${CALL_DATA.localIdentity}2`; // 1 mic, 2 Camera
        CustomToast.info(waitingToastText, 10000, true, WAITING_CLOCK_ICON, {
            toastId: uniqueKey,
        });
        return true;
    }
    return false;
};
